<script lang="ts">
    import {BicycleIcon, CarIcon, PedestrianIcon, TruckIcon } from "@anyways-open/common-svgs";
    import type { ProfileRowManager } from "./ProfileRowManager";
    import { derived } from "svelte/store";

    export let manager: ProfileRowManager;
    let visible = manager.getVisibleStore();
    let profile = manager.getProfileStore();
    let color = manager.getColorStore();
    let profiles = manager.getProfiles();

    let vehicleType = derived(profile, ($profile) => {
        return $profile.substring(0, $profile.indexOf("."));
    });
</script>

<div class="row py-1 gx-0">
    <div class="d-flex">
        <div class="svg-icon-sm pe-1">
            {#if $vehicleType == "car"}
                <CarIcon />
            {:else if $vehicleType == "bicycle"}
                <BicycleIcon />
            {:else if $vehicleType == "pedestrian"}
                <PedestrianIcon />
            {:else if $vehicleType == "bigtruck"}
                <TruckIcon />
            {/if}
        </div>
        <select
            class="fs-tool form-select form-select-tool "
            bind:value={$profile}>
            {#each profiles as profile}
                <option value={`${profile}`}>
                    {`${profile}`}
                </option>
            {/each}
        </select>
         <input
            class="badge-color-picker ms-auto"
            type="color"
            bind:value={$color} />
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
            class="btn badge badge-rounded-circle badge-success-soft ms-1"
            on:click={() => {
                $visible = !$visible;
            }}>
            {#if $visible}
                <i class="fe fe-eye" />
            {:else}
                <i class="fe fe-eye-off" />
            {/if}
        </div>
    </div>
</div>

<style>

    .badge-color-picker {
        margin-top: 2px;
    }
</style>
